var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0417 14.4358H24.9475C21.59 14.4358 18.8559 11.7017 18.8559 8.34416V4.24999C18.8559 3.47083 18.2184 2.83333 17.4392 2.83333H11.4325C7.06919 2.83333 3.54169 5.66666 3.54169 10.7242V23.2758C3.54169 28.3333 7.06919 31.1667 11.4325 31.1667H22.5675C26.9309 31.1667 30.4584 28.3333 30.4584 23.2758V15.8525C30.4584 15.0733 29.8209 14.4358 29.0417 14.4358Z",
    fill: "#3C3D3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3829 3.13152C21.8021 2.55068 20.7963 2.94735 20.7963 3.75485V8.69902C20.7963 10.7673 22.5529 12.4815 24.6921 12.4815C26.0379 12.4957 27.9079 12.4957 29.5088 12.4957C30.3163 12.4957 30.7413 11.5465 30.1746 10.9798C28.1346 8.92568 24.4796 5.22818 22.3829 3.13152Z",
    fill: "#3C3D3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument1);
export default __webpack_public_path__ + "static/media/document-1.d1ba126f2ed045b0802224731db829ca.svg";
export { ForwardRef as ReactComponent };